import { eventConfirm } from "@/api/apiMethods.js";
import userStore from "@/utils/userStore";
export const toClaimFn = async (matchedData) => {
  console.log(matchedData, userStore.user.id);
  try {
    await eventConfirm({ oid: matchedData[0].id, uid: userStore.user.id });
    // message.success('Claim Successfully');
  } catch (error) {
    console.log(error);
  }
};
